import ActionBarItem from '@rio-cloud/rio-uikit/ActionBarItem';
import ReleaseNotesDialog from '@rio-cloud/rio-uikit/ReleaseNotesDialog';
import { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

export const CUSTOMER_CENTER_RELEASE_NOTES_VERSION = '2026.09';
export const CUSTOMER_CENTER_RELEASE_NOTES_STORAGE_KEY = 'customer-center-release-notes-version';
export const FEEDBACK_URL = 'https://contact-form.rio.cloud/contact?reason=feedback';

export const InformationActionBarItem = () => {
    const [showReleaseNotes, setShowReleaseNotes] = useState(false);
    const intl = useIntl();
    const moduleName = intl.formatMessage({ id: 'marketplace.customerCenter' });
    const whatsNewTitle = intl.formatMessage({ id: 'marketplace.customerCenter.info.whatsNew' });
    const releaseDate = intl.formatDate(Date.UTC(2026, 8, 1), {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        timeZone: 'UTC',
    });

    return (
        <>
            <ActionBarItem id='customer-center-information' popoverWidth={300}>
                <ActionBarItem.Icon title={moduleName}>
                    <span className='icon rioglyph rioglyph-info-sign' />
                </ActionBarItem.Icon>
                <ActionBarItem.Popover title={moduleName}>
                    <ActionBarItem.List>
                        <ActionBarItem.ListItem icon='rioglyph-info-sign'>
                            <div className='display-flex justify-content-between gap-10 width-100pct'>
                                <span>{moduleName}</span>
                                <span>{CUSTOMER_CENTER_RELEASE_NOTES_VERSION}</span>
                            </div>
                        </ActionBarItem.ListItem>
                        <ActionBarItem.ListItem icon='rioglyph-document' onClick={() => setShowReleaseNotes(true)}>
                            {whatsNewTitle}
                        </ActionBarItem.ListItem>
                        <ActionBarItem.ListItem icon='rioglyph-send' hasLink>
                            <a href={FEEDBACK_URL} target='_blank' rel='noreferrer'>
                                <FormattedMessage id='marketplace.customerCenter.info.feedback' />
                            </a>
                        </ActionBarItem.ListItem>
                    </ActionBarItem.List>
                </ActionBarItem.Popover>
            </ActionBarItem>
            <ReleaseNotesDialog
                showReleaseNotes={showReleaseNotes}
                setShowReleaseNotes={setShowReleaseNotes}
                moduleName={moduleName}
                whatsNewTitle={whatsNewTitle}
                closeButtonText={intl.formatMessage({ id: 'marketplace.customerCenter.info.close' })}
                translatedReleaseNotes={{
                    [CUSTOMER_CENTER_RELEASE_NOTES_VERSION]: {
                        date: releaseDate,
                        content: [
                            <FormattedMessage key='minimum-term' id='intl-msg:slider.oneMonthBooking.content' />,
                            <FormattedMessage
                                key='automatic-renewal'
                                id='intl-msg:slider.oneMonthBooking.readMoreText3'
                            />,
                        ],
                    },
                }}
                currentVersion={CUSTOMER_CENTER_RELEASE_NOTES_VERSION}
                RELEASE_NOTES_ITEM={CUSTOMER_CENTER_RELEASE_NOTES_STORAGE_KEY}
            />
        </>
    );
};
